import { http } from '../../../libs/util';
import { util_api } from '../../../libs/util_api';
const util = {
  find(id) {
    return http.get(util_api.find_contract, { id });
  },
  getDetail(id) {
    return http.get(util_api.contract_detail, { id });
  },
  delLinkContract(contract_id, link_contract_id) {
    return http.post(util_api.delete_link_contract, {
      contract_id: contract_id,
      link_contract_id: link_contract_id
    });
  }
};

export default util;
